import { TVideoType } from '../../types';

export const PLAYABLE_VIDEO_TYPES: TVideoType[] = ['kinescope'];
